import { CourseMappingColumn } from '../../interfaces/CourseMappingInterface';

export const COURSE_MAPPING_COLUMNS: CourseMappingColumn[] = [
  { key: 'name', label: 'Course name', cellType: 'locked' },
  { key: 'code', label: 'Course ID', cellType: 'locked' },
  { key: 'schoolName', label: 'School name', cellType: 'locked' },
  { key: 'academicPeriod', label: 'Year', cellType: 'locked' },
  { key: 'subjectArea', label: 'Subject area', cellType: 'dropdown' },
  { key: 'subjectSubcategory', label: 'Subject subcategory', cellType: 'dropdown' },
  { key: 'numberOfCredits', label: 'Credits', cellType: 'editable' },
  { key: 'languageCategory', label: 'Lang category', cellType: 'dropdown' },
  { key: 'languageLevel', label: 'Lang level', cellType: 'dropdown' },
  { key: 'isCollegePreparatory', label: 'Coll prep', cellType: 'checkbox' },
  { key: 'isHonors', label: 'Honors', cellType: 'checkbox' },
  { key: 'isAp', label: 'AP', cellType: 'checkbox' },
  { key: 'isIb', label: 'IB', cellType: 'checkbox' },
  { key: 'isAice', label: 'AICE', cellType: 'checkbox' },
  { key: 'isDualEnrollment', label: 'Dual Enroll', cellType: 'checkbox' },
  { key: 'isCte', label: 'CTE', cellType: 'checkbox' },
  { key: 'isLabScience', label: 'Lab Science', cellType: 'checkbox' },
];
